import BrandSignature from './BrandSignature';

function HeroOrbital({ brandLogo }) {
  return (
    <div className="hero-orbital">
      <div className="orbital-grid" />
      <BrandSignature brandLogo={brandLogo} label="Secure Experience Systems" />

      <div className="hero-orbital-stage">
        <div className="logo-orb">
          <div className="logo-ring logo-ring-one" />
          <div className="logo-ring logo-ring-two" />
          <div className="logo-core">
            <img alt="ATA Code House center mark" src={brandLogo} />
          </div>
        </div>

        <div className="hero-signal-grid">
          <div className="signal-card signal-card-top">
            <span>UI / UX</span>
            <strong>Premium product motion</strong>
          </div>
          <div className="signal-card signal-card-right">
            <span>Bot</span>
            <strong>Automation-ready flows</strong>
          </div>
          <div className="signal-card signal-card-left">
            <span>Web</span>
            <strong>Frontend architecture</strong>
          </div>
          <div className="signal-card signal-card-bottom">
            <span>App</span>
            <strong>Checkout and dashboard logic</strong>
          </div>
        </div>
      </div>

      <div className="hero-code-panel">
        <div className="window-top">
          <span />
          <span />
          <span />
        </div>
        <div className="hero-code-lines">
          <p>{'>'} initialize showcase</p>
          <p>{'>'} enforce secure build standards</p>
          <p>{'>'} deliver smooth client-ready systems</p>
        </div>
      </div>
    </div>
  );
}

export default HeroOrbital;
